import { SVGInterface } from "../../interface";

const Share = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M17.5003 22C16.4183 22.0125 15.3927 21.518 14.7286 20.6637C14.0645 19.8093 13.8383 18.6935 14.1173 17.648L7.85734 14.07C6.77562 15.061 5.19002 15.2707 3.88782 14.5951C2.58563 13.9194 1.84421 12.5022 2.0317 11.0472C2.2192 9.59214 3.29566 8.4092 4.72661 8.0857C6.15756 7.76221 7.63819 8.36708 8.43334 9.59996L14.1163 6.35096C14.0428 6.07314 14.0038 5.78732 14.0003 5.49996C13.986 3.82667 15.1481 2.3731 16.7835 2.01878C18.4189 1.66446 20.0785 2.5067 20.758 4.03588C21.4375 5.56505 20.9503 7.36119 19.5913 8.33747C18.2323 9.31375 16.3746 9.20205 15.1423 8.06996L8.99134 11.585C8.98524 11.8443 8.949 12.102 8.88334 12.353L15.1423 15.93C16.2946 14.8725 18.0091 14.7093 19.3402 15.5303C20.6713 16.3513 21.295 17.9567 20.8672 19.461C20.4394 20.9653 19.0643 22.0023 17.5003 22ZM17.5003 17C16.6719 17 16.0003 17.6715 16.0003 18.5C16.0003 19.3284 16.6719 20 17.5003 20C18.3288 20 19.0003 19.3284 19.0003 18.5C19.0003 17.6715 18.3288 17 17.5003 17ZM5.50034 9.99996C4.67191 9.99996 4.00034 10.6715 4.00034 11.5C4.00034 12.3284 4.67191 13 5.50034 13C6.32876 13 7.00034 12.3284 7.00034 11.5C7.00034 10.6715 6.32876 9.99996 5.50034 9.99996ZM17.5003 3.99996C16.6719 3.99996 16.0003 4.67153 16.0003 5.49996C16.0003 6.32839 16.6719 6.99996 17.5003 6.99996C18.3288 6.99996 19.0003 6.32839 19.0003 5.49996C19.0003 4.67153 18.3288 3.99996 17.5003 3.99996Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Share;
